import { createFileRoute } from "@tanstack/react-router";
import { TestMfePage } from "@/pages/TestMfe/TestMfePage";
import { requireSession } from "../shell-handle/bootGate";

export const Route = createFileRoute("/test-mfe")({
  beforeLoad: () => requireSession(),
  component: TestMfePage,
});
